<template>
  <v-layout row wrap class="ch-search-filter-wrapper">
    <v-flex xs12 class="ch-search-filter pb-0 pt-0">
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-container fluid grid-list-lg class="pt-0 pb-0">
          <v-layout row wrap class="filter-wrap">
            <button class="form-clear-btn" @click.prevent="clearAllField">
              <i class="fas fa-eraser"></i>
              <span>CLEAR</span>
            </button>
            <v-flex xs2 class="pl-0 pr-0">
              <v-text-field
                v-model="filterName"
                label="Name"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
  import _ from 'lodash';
  import { storeFilterEventBus } from '@/components/customized-components/storeFilterEventBus';
  import { domainsEventBus } from '@/components/admin/domains/domainsEventBus';

  export default {
    props: ['storeFilter'],
    data() {
      return {
        // NOTE: 모든 검색어
        allSearch: {
          name: {
            search: null,
            searchCategory: 'name',
          },
        },
        valid: true,
        filterName: null,
      };
    },
    methods: {
      /**
       * @description 상세 => 목록으로 넘어올 경우 필터값을 유지, 컴포넌트가 렌더링될 때 최초 한번만 실행
       */
      init() {
        if (!_.isEmpty(this.storeFilter)) {
          console.log('this.storeFilter not empty');
          const filter = Object.values(this.storeFilter).filter(item => item.search !== null);
          const arr = Object.keys(this.allSearch);
          for (let i = 0; i < arr.length; i += 1) {
            for (let j = 0; j < filter.length; j += 1) {
              if (this.allSearch[arr[i]].searchCategory === filter[j].searchCategory) {
                this.allSearch[arr[i]].search = filter[j].search;
                switch (this.allSearch[arr[i]].searchCategory) {
                  case 'name':
                    this.filterName = filter[j].search;
                    break;
                  default:
                    break;
                }
              }
            }
          }
          this.$nextTick(() => {
            console.log('this.$nextTick');
            domainsEventBus.$emit('initFilter', this.allSearch);
          });
        }
      },
      clearAllField() {
        this.$refs.form.reset();
      },
      /**
       * @description 사용자가 입력을 기다리는 시간(밀리세컨드) 입니다.
       * @param { Object } object, this.allSearch
       */
      getInputValue: _.debounce((obj) => {
        domainsEventBus.$emit('customFilter', obj);
        storeFilterEventBus.$emit('setFilter', obj);
      }, 100),
    },
    watch: {
      /**
       * @description 작업을 실행할 수 있는 빈도를 제한합니다
       */
      filterName(newValue) {
        console.log('filterName');
        this.allSearch.name.search = newValue;
        this.getInputValue(this.allSearch);
      },
    },
    mounted() {
      this.init();
    },
    beforeDestroy() {
      domainsEventBus.$off('initFilter');
      domainsEventBus.$off('customFilter');
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/domains/DomainsFilter.vue